export default __webpack_public_path__ + "static/media/icon_youtube.b8b89006.svg";